const { createSlice } = require("@reduxjs/toolkit");

const projectSlice = createSlice({
  name: "project",
  initialState: {
    rowData: [],
    stepData: [],
    hasBack: false,
    hasBackOrderForm: false,
    orderFormData: {}, // Updated to store form data as an object
  },
  reducers: {
    setRowDataValue: (state, action) => {
      state.rowData = action.payload;
    },
    setPreviousStepData: (state, action) => {
      const { stepIndex, data } = action.payload;
      state.stepData[stepIndex] = {
        ...state.stepData[stepIndex],
        ...data,
        uploadValue: [
          ...(state.stepData[stepIndex]?.uploadValue || []),
          ...(data.uploadValue || []),
        ],
      };
    },
    setHasBack: (state, action) => {
      state.hasBack = action.payload;
    },
    setHasBackOrderForm: (state, action) => {
      state.hasBackOrderForm = action.payload;
    },
    clearRowDataValue: (state) => {
      state.rowData = [];
    },
    clearStepData: (state) => {
      state.stepData = [];
      state.hasBack = false;
    },
    // New reducer to store order form data
    setOrderFormData: (state, action) => {
      state.orderFormData = {
        selectedProName: action.payload.selectedProName,
        product: action.payload.product,
        selectedQty: action.payload.selectedQty,
        selectedPhases: action.payload.selectedPhases,
        phasesRowData: action.payload.phasesRowData,
        phasesTotalValue: action.payload.phasesTotalValue,
        displayName: action.payload.displayName,
        phaseNameCode: action.payload.phaseNameCode,
        typesPhaseQty: action.payload.typesPhaseQty,
        rowData: action.payload.rowData,
        typeTotalValue: action.payload.typeTotalValue,
      };
    },
    clearOrderFormData: (state) => {
      state.orderFormData = {}; // Reset form data
    },
  },
});

export const {
  setPreviousStepData,
  setHasBack,
  setRowDataValue,
  clearRowDataValue,
  setHasBackOrderForm,
  clearStepData,
  setOrderFormData,
  clearOrderFormData,
} = projectSlice.actions;

export default projectSlice.reducer;
